module.exports = __webpack_public_path__ + "img/phenotype-cov-hum-6.f5edcadc.png";